const common = {
  "site.name": "YOYBUY.PRO",
  "site.tagline": "YOYBUY Spreadsheet — Ваш умный помощник для покупок из Китая",
  "site.description": "Система таблиц для заказа товаров из Китая. Сравнивайте цены, отслеживайте заказы и экономьте до 40% с YOYBUY Spreadsheet.",

  "nav.home": "Главная",
  "nav.categories": "Категории",
  "nav.guides": "Гайды",
  "nav.shopping_guide": "Гид по покупкам",
  "nav.contact": "Контакты",

  "hero.title_1": "YOYBUY",
  "hero.title_2": "Spreadsheet",
  "hero.subtitle": "Умная система таблиц для заказа товаров из Китая. Сравнивайте, отслеживайте и экономьте — всё в одном месте.",
  "hero.cta_sheet": "YOYBUY SHEET",
  "hero.cta_buy": "BUY IT NOW",

  "categories.title": "Категории товаров",
  "categories.subtitle": "Выбирайте из тысяч проверенных товаров. Все категории с прямыми ссылками на таблицы заказов.",
  "categories.all_title": "Все категории товаров",
  "categories.all_subtitle": "Выбирайте категорию и переходите к таблице заказов на Kaspreadsheet",

  "trust.title": "Почему YOYBUY Spreadsheet?",
  "trust.stat_1": "Товаров в базе",
  "trust.stat_2": "Категорий",
  "trust.stat_3": "Обновлений в день",
  "trust.desc_1": "Огромный каталог проверенных товаров из Китая с актуальными ценами и наличием.",
  "trust.desc_2": "От обуви до аксессуаров — все категории в удобных таблицах для быстрого заказа.",
  "trust.desc_3": "Ежедневное обновление данных о ценах и наличии, чтобы вы всегда были в курсе.",

  "seo.title": "Руководства и статьи YOYBUY Spreadsheet",
  "seo.subtitle": "Узнайте всё о покупках из Китая. Сравнения, инструкции, советы и аналитика — все статьи с уникальным контентом.",
  "seo.read_more": "Читать статью",

  "articles.guide.title": "YOYBUY Spreadsheet: Полное руководство",
  "articles.guide.desc": "Узнайте, как использовать YOYBUY Spreadsheet для выгодных покупок из Китая. Пошаговое руководство для начинающих.",
  "articles.guide.tag": "Руководство",

  "articles.compare.title": "YOYBUY vs конкуренты: сравнение spreadsheet-систем",
  "articles.compare.desc": "Честное сравнение систем таблиц для покупок из Китая. Плюсы и минусы каждого решения.",
  "articles.compare.tag": "Сравнение",

  "articles.howto.title": "Как покупать из Китая: пошаговое руководство",
  "articles.howto.desc": "Полная инструкция по заказу товаров из Китая через YOYBUY Spreadsheet. От поиска до доставки.",
  "articles.howto.tag": "Инструкция",

  "articles.vs_kakobuy.title": "YOYBUY Spreadsheet vs Kakobuy: что лучше в 2026?",
  "articles.vs_kakobuy.desc": "Детальное сравнение YOYBUY и Kakobuy. Таблицы, комиссии, скорость доставки — все аспекты в одном обзоре.",
  "articles.vs_kakobuy.tag": "Сравнение",

  "articles.kakobuy_alt.title": "Альтернативы Kakobuy: почему YOYBUY Spreadsheet выигрывает",
  "articles.kakobuy_alt.desc": "Обзор лучших альтернатив Kakobuy. Как YOYBUY Spreadsheet помогает экономить на заказах из Китая.",
  "articles.kakobuy_alt.tag": "Обзор",

  "articles.vs_superbuy.title": "Superbuy против YOYBUY Spreadsheet: полный разбор",
  "articles.vs_superbuy.desc": "Сравниваем Superbuy и YOYBUY Spreadsheet: комиссии, удобство таблиц, скорость обработки заказов.",
  "articles.vs_superbuy.tag": "Сравнение",

  "articles.taobao_guide.title": "Как покупать на TaoBao через Spreadsheet: полный гид",
  "articles.taobao_guide.desc": "Пошаговая инструкция по заказу товаров с TaoBao через систему таблиц YOYBUY. От регистрации до получения.",
  "articles.taobao_guide.tag": "Инструкция",

  "articles.shipping.title": "Доставка из Китая: полный гид по стоимости и срокам",
  "articles.shipping.desc": "Калькуляция стоимости доставки, сравнение перевозчиков, сроки и таможенные нюансы при заказе из Китая.",
  "articles.shipping.tag": "Гид",

  "articles.wholesale.title": "Оптовые закупки из Китая: руководство для перепродавцов",
  "articles.wholesale.desc": "Как находить выгодные оптовые партии через YOYBUY Spreadsheet. Расчёт прибыли и стратегии закупок.",
  "articles.wholesale.tag": "Бизнес",

  "articles.safety.title": "Безопасные покупки из Китая: как не попасть на мошенников",
  "articles.safety.desc": "Проверенные способы защиты при заказе из Китая. Как YOYBUY Spreadsheet исключает риски.",
  "articles.safety.tag": "Безопасность",

  "articles.best_agent.title": "Лучшие агенты Китая 2026: рейтинг и сравнение",
  "articles.best_agent.desc": "Объективный рейтинг китайских агентов-посредников. Почему таблицы YOYBUY выигрывают у традиционных агентов.",
  "articles.best_agent.tag": "Рейтинг",

  "articles.scams.title": "Как избежать мошенничества при заказе из Китая: 7 правил",
  "articles.scams.desc": "Распространённые схемы обмана при покупках из Китая и как YOYBUY Spreadsheet защищает ваш заказ.",
  "articles.scams.tag": "Защита",

  "testimonial.quote": "YOYBUY Spreadsheet полностью изменил мой подход к закупкам из Китая. Я экономлю минимум 30% на каждом заказе и всегда знаю актуальные цены.",
  "testimonial.name": "Алексей М.",
  "testimonial.role": "Предприниматель, Москва",

  "cta.title": "Готовы начать покупать выгодно?",
  "cta.subtitle": "Переходите на Kaspreadsheet и получите доступ к полной системе таблиц для заказа товаров из Китая.",
  "cta.button": "Перейти на Kaspreadsheet",

  "footer.subscribe_title": "Будьте в курсе",
  "footer.subscribe_desc": "Подпишитесь на обновления и получайте новые таблицы и категории первыми.",
  "footer.subscribe_btn": "Подписаться",
  "footer.subscribe_placeholder": "Ваш email",
  "footer.categories_title": "Категории",
  "footer.contact_title": "Контакты",
  "footer.address": "Работаем по всему миру. Доставка из Китая в любую точку.",
  "footer.copyright": "© 2026 YOYBUY.PRO. Все права защищены.",
  "footer.privacy": "Политика конфиденциальности",
  "footer.terms": "Условия использования",

  "dropdown.placeholder": "Выберите категорию",
  "dropdown.go": "Перейти",
  "dropdown.opened": "Страница открыта в новой вкладке",

  "article.back": "← На главную",
  "article.home": "На главную",
  "article.read_more_home": "← Вернуться на главную страницу YOYBUY.PRO",
  "article.cta": "Перейти к YOYBUY SHEET",

  "mobile.menu": "Меню",
  "mobile.close": "Закрыть",
};

export default common;